import { ContractAside } from './ContractAside';
import { useFinancials } from './editor';
import { ProjectOverviewAside } from './ProjectOverviewAside';

/**
 * The Financials right panel (the fixed 340px rail): the active contract
 * (`ContractAside`), or the project overview across every contract
 * (`ProjectOverviewAside`) — two views since 3 Nov (Mette), as Planning's panel
 * shows a task or the project. "Show project summary" on the collapse row
 * (`FinancialsDrawerHeading`) opens the overview; picking a contract anywhere
 * comes back. The zero-contract aside is `ProjectBudgetAsideEmpty`.
 */
export const ProjectBudgetAside = () => {
  const { asideView } = useFinancials();
  return asideView === 'project' ? <ProjectOverviewAside /> : <ContractAside />;
};
